"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyPress = void 0;
var react_1 = require("react");
/*
    useKeyPress' targetKey takes in the event.key value
    https://keycode.info/ <- use this to find out the event.key value for your specific key
*/
function useKeyPress(_a) {
    var ref = _a.ref, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, targetKey = _a.targetKey, _b = _a.enabled, enabled = _b === void 0 ? false : _b, _c = _a.single, single = _c === void 0 ? true : _c;
    // State for keeping track of whether key is pressed
    var _d = __read(react_1.useState(false), 2), keyPressed = _d[0], setKeyPressed = _d[1];
    var fired = react_1.useRef({});
    // reset all keys
    var resetAll = function () {
        fired.current = {};
    };
    // If pressed key is our target key then set to true
    function downHandler(_a) {
        var key = _a.key;
        var otherKeyPressed = Object.values(fired.current).find(function (e) { return e; });
        if (key === targetKey && (!single || !otherKeyPressed)) {
            setKeyPressed(true);
            onKeyDown && onKeyDown();
            resetAll();
        }
        if (single) {
            fired.current[key] = true;
        }
    }
    // If released key is our target key then set to false
    var upHandler = function (_a) {
        var key = _a.key;
        var otherKeyPressed = Object.values(fired.current).find(function (e) { return e; });
        if (key === targetKey && (!single || !otherKeyPressed)) {
            setKeyPressed(false);
            onKeyUp && onKeyUp();
            resetAll();
        }
        if (single) {
            fired.current[key] = undefined;
        }
    };
    var currentRef = ref === null || ref === void 0 ? void 0 : ref.current;
    // Add event listeners
    react_1.useEffect(function () {
        if (enabled) {
            if (currentRef) {
                currentRef.addEventListener('keydown', downHandler);
                currentRef.addEventListener('keyup', upHandler);
                currentRef.addEventListener('blur', resetAll);
                currentRef.addEventListener('focus', resetAll);
                // Remove event listeners on cleanup
                return function () {
                    currentRef.removeEventListener('keydown', downHandler);
                    currentRef.removeEventListener('keyup', upHandler);
                    currentRef.removeEventListener('blur', resetAll);
                    currentRef.removeEventListener('focus', resetAll);
                };
            }
            window.addEventListener('keydown', downHandler);
            window.addEventListener('keyup', upHandler);
            window.addEventListener('blur', resetAll);
            window.addEventListener('focus', resetAll);
            // Remove event listeners on cleanup
            return function () {
                window.removeEventListener('keydown', downHandler);
                window.removeEventListener('keyup', upHandler);
                window.removeEventListener('blur', resetAll);
                window.removeEventListener('focus', resetAll);
            };
        }
    }, [enabled, currentRef, downHandler, upHandler]);
    return keyPressed;
}
exports.useKeyPress = useKeyPress;
function areKeysPressed(keys, keysPressed) {
    var e_1, _a;
    if (keys === void 0) { keys = []; }
    if (keysPressed === void 0) { keysPressed = new Set([]); }
    var required = new Set(keys);
    try {
        for (var keysPressed_1 = __values(keysPressed), keysPressed_1_1 = keysPressed_1.next(); !keysPressed_1_1.done; keysPressed_1_1 = keysPressed_1.next()) {
            var elem = keysPressed_1_1.value;
            required.delete(elem);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keysPressed_1_1 && !keysPressed_1_1.done && (_a = keysPressed_1.return)) _a.call(keysPressed_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return required.size === 0;
}
function useMultiKeyPress(_a) {
    var ref = _a.ref, onMatch = _a.onMatch, targetKeys = _a.targetKeys, _b = _a.enabled, enabled = _b === void 0 ? false : _b;
    var _c = __read(react_1.useState(new Set([])), 2), keysPressed = _c[0], setKeyPressed = _c[1];
    function downHandler(_a) {
        var key = _a.key;
        setKeyPressed(keysPressed.add(key));
    }
    var upHandler = function (_a) {
        var key = _a.key;
        keysPressed.delete(key);
        setKeyPressed(keysPressed);
    };
    var currentRef = ref === null || ref === void 0 ? void 0 : ref.current;
    react_1.useEffect(function () {
        if (enabled) {
            if (currentRef) {
                currentRef.addEventListener('keydown', downHandler);
                currentRef.addEventListener('keyup', upHandler);
                // Remove event listeners on cleanup
                return function () {
                    currentRef.removeEventListener('keydown', downHandler);
                    currentRef.removeEventListener('keyup', upHandler);
                };
            }
            window.addEventListener('keydown', downHandler);
            window.addEventListener('keyup', upHandler);
            // Remove event listeners on cleanup
            return function () {
                window.removeEventListener('keydown', downHandler);
                window.removeEventListener('keyup', upHandler);
            };
        }
    }, [enabled, currentRef, downHandler, upHandler]);
    var matchKeys = areKeysPressed(targetKeys, keysPressed);
    react_1.useEffect(function () {
        if (matchKeys) {
            onMatch && onMatch();
        }
    }, [matchKeys]);
    return keysPressed;
}
exports.default = useMultiKeyPress;
//# sourceMappingURL=useKeyPress.js.map